import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import score from 'src/helper/score'
import CD from 'src/component/CountDown'
import SVGA from 'svgaplayerweb'
import RuleButton from '../../../component/RuleButton'
import { openStore } from 'src/helper/openStore'
import Toast from '../../../component/Toast'

@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.ramadan = this.props.store.register('activity/ramadan')
    setDocumentTitle('Ramadan Invite')
  }

  state = {
    lang: langM.ar,
    isEmptyUid: false,
    rwList: [
      {
        type: 'svga',
        img: "/img/activity/ramadan/help/rw/cat_h.svga",
        name: "IP Special Head",
        date: "*15days"
      },
      {
        img: "https://d12o7ht18lg4ku.cloudfront.net/app/noble/viscount.png",
        name: "VIP"
      },
      {
        type: 'svga',
        img: "/img/activity/ramadan/help/rw/medal.svga",
        name: "Medal"
      },
      {
        img: "/img/activity/ramadan/help/rw/c.png",
        name: "Car"
      },
      {
        type: 'svga',
        img: "/img/activity/ramadan/help/rw/head.svga",
        name: "Head"
      },
      {
        img: "/img/activity/ramadan/help/rw/gift.png",
        name: "Special Gift"
      },
    ],
    desc: "",
    userInfo: "",
    inpCode: null,
    cd: 0,
    language:'en',
  }

  async componentWillMount() {
    // 控制台调试
    let { language } = this.props.location.query
    language =await getlang(language)
    console.log('language', language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uidx = await setUidToken(this.props.location.query)
    console.log(uidx, 'uid')
    await this.RunOnStart(uidx)

    await this.ramadan.GetUserInfoWeb(uidx)

    let cd = await this.ramadan.jigsawCd()

    this.setState({
      inviteCode: this.props.location.query.code,
      cd: cd
    })

    // 判断用户是否有登录?
    let { uid, accesstoken } = this.props.location.query
    if (!uidx) {
      this.setState({
        isEmptyUid: true
      })
    } else {
      this.setState({
        isEmptyUid: false
      })
    }

    // // 从正常网页进来，有登录态，非新人，老用户，调用该用户的状态码
    // if (userCode) {
    //   let shareCode = window.location.origin + `/#/activity/ramadanHelp?code=${userCode}`
    //   console.log(shareCode, 'shareCode');
    // } else {
    //   // 没有登录态
    //   if (this.props.location.query.code) {   // 从链接进来
    //     let codeRes = await this.ramadan.addJigsawShareCode(this.props.location.query.code)
    //     console.log(codeRes, 'codeRes');
    //   } else {

    //   }
    // }

    // 进入页面，判断是否有登录态，有就调用状态码，代表这个人非新用户
    // let userCode = await this.ramadan.getCode()
    // console.log(userCode, 'userCode');
    // let shareCode = window.location.origin + `/#/activity/ramadanHelp?code=${userCode}`
    // console.log(shareCode, 'shareCode');

    // let userCode = await this.ramadan.getCode()
    // console.log(userCode, 'userCode');

    // // 未登录。url有code的情况下
    // if (this.props.location.query.code) {
    //   let userCode = this.props.location.query.code || 0
    //   let codeRes = await this.ramadan.addJigsawShareCode(userCode)  // 这个接口不用权限
    //   console.log(codeRes, 'codeRes');
    // }
    // // 已登录，显示助力
    // if (uidx) {
    //   // 有登录态的时候调用，展示被助力用户
    //   let user = await this.ramadan.getJigsawHelpUser()
    //   console.log(user, 'user');
    //   this.setState({
    //     userInfo: user
    //   })
    // }


    let info = await this.ramadan.inviteRewardInfo()
    this.setState({
      inviteTotal: info && info.num,
      rw1: info && info.list && info.list[0],
      rw2: info && info.list && info.list[1],
      rw3: info && info.list && info.list[2],
      rw4: info && info.list && info.list[3],
    })
    console.log(info)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // ()
    // 用户id
    this.setState({
      uid: uid
    })
  }

  componentDidMount() {
    new SVGA.autoload(document.querySelector('#svga'))
    new SVGA.autoload(document.querySelector('#svga2'))
    new SVGA.autoload(document.querySelector('#svga3'))
  }

  timeComp({ langtxt, daytxt, day, hour, mi, se }) {
    return (
      <div className="timer">
        <div className="d time-box"></div>
        <div className="d time-box"></div>
        <div className="d time-box"></div>
        <div className="d time-box"></div>
        <div className="d time-box">
          {day}
        </div>
        <div className="d time-box">
          Day
        </div>
        <div className="h time-box">
          {hour}
        </div>
        <div>
          :
        </div>
        <div className="m time-box">
          {mi}
        </div>
        <div>
          :
        </div>
        <div className="s time-box">
          {se}
        </div>
      </div>
    )
  }

  async helpUser() {
    if (this.state.inpCode == null || this.state.inpCode == "") {
      this.setState({
        desc: this.state.lang.noNull
      })
      this.refs.toast.hideRule(true)
      return
    }
    let isHelpSuccess = await this.ramadan.jigsawHelp(this.state.inpCode)
    console.log(isHelpSuccess);
    if (isHelpSuccess && isHelpSuccess.msg == "You are not a new user") {
      this.setState({
        desc: this.state.lang.noHelp
      })
      this.refs.toast.hideRule(true)
      return
    }
    if (isHelpSuccess && isHelpSuccess.msg == "Invalid code") {
      this.setState({
        desc: this.state.lang.noCode
      })
      this.refs.toast.hideRule(true)
      return
    }
    if (isHelpSuccess && isHelpSuccess.msg == "Cannot repeatedly assist") {
      this.setState({
        desc: this.state.lang.hadHelp
      })
      this.refs.toast.hideRule(true)
      return
    }
    if (isHelpSuccess && isHelpSuccess.code == 0) {
      this.setState({
        desc: this.state.lang.sucHelp
      })
      this.refs.toast.hideRule(true)
      return
    }
  }

  goAppShop() {
    openStore()
  }

  ruleContentComp = (open, close, lang) => {
    return (
      <div className="ramadan-jigsaw-help-rule-content-main" onClick={() => { close() }}>
        <div className="ramadan-jigsaw-help-rule-title">
          {this.state.lang.rule}
        </div>
        <div className="ramadan-jigsaw-help-rule-content"
          style={{
            direction: `${this.state.language == 'ar' ? "rtl" : ""}`
          }}
          dangerouslySetInnerHTML={{ __html: this.state.lang.ruleContent }}></div>
      </div>
    )
  }

  async onHandleGainRw(state) {
    switch (state) {
      case 1:
        if (this.state.rw1 && this.state.rw1.canGet) {
          try {
            let gainRw = await this.ramadan.gainInviteReward(1)
            console.log(gainRw)
            if (gainRw == 0) {
              this.setState({
                desc: this.state.lang.getSuc
              })
              this.refs.toast.hideRule(true)
              let info = await this.ramadan.inviteRewardInfo()
              this.setState({
                inviteTotal: info && info.num,
                rw1: info && info.list && info.list[0],
                rw2: info && info.list && info.list[1],
                rw3: info && info.list && info.list[2],
                rw4: info && info.list && info.list[3],
              })
            }
          } catch (error) {
            console.error(error)
            return error
          }
        }
        break
      case 2:
        if (this.state.rw2 && this.state.rw2.canGet) {
          try {
            let gainRw = await this.ramadan.gainInviteReward(2)
            console.log(gainRw)
            if (gainRw == 0) {
              this.setState({
                desc: this.state.lang.getSuc
              })
              this.refs.toast.hideRule(true)
              let info = await this.ramadan.inviteRewardInfo()
              this.setState({
                inviteTotal: info && info.num,
                rw1: info && info.list && info.list[0],
                rw2: info && info.list && info.list[1],
                rw3: info && info.list && info.list[2],
                rw4: info && info.list && info.list[3],
              })
            }
          } catch (error) {
            console.error(error)
            return error
          }
        }
        break
      case 3:
        if (this.state.rw3 && this.state.rw3.canGet) {
          try {
            let gainRw = await this.ramadan.gainInviteReward(3)
            console.log(gainRw)
            if (gainRw == 0) {
              this.setState({
                desc: this.state.lang.getSuc
              })
              this.refs.toast.hideRule(true)
              let info = await this.ramadan.inviteRewardInfo()
              this.setState({
                inviteTotal: info && info.num,
                rw1: info && info.list && info.list[0],
                rw2: info && info.list && info.list[1],
                rw3: info && info.list && info.list[2],
                rw4: info && info.list && info.list[3],
              })
            }
          } catch (error) {
            console.error(error)
            return error
          }
        }
        break
      case 4:
        if (this.state.rw4 && this.state.rw4.canGet) {
          try {
            let gainRw = await this.ramadan.gainInviteReward(4)
            console.log(gainRw)
            if (gainRw == 0) {
              this.setState({
                desc: this.state.lang.getSuc
              })
              this.refs.toast.hideRule(true)
              let info = await this.ramadan.inviteRewardInfo()
              this.setState({
                inviteTotal: info && info.num,
                rw1: info && info.list && info.list[0],
                rw2: info && info.list && info.list[1],
                rw3: info && info.list && info.list[2],
                rw4: info && info.list && info.list[3],
              })
            }
          } catch (error) {
            console.error(error)
            return error
          }
        }
        break
    }
  }

  copyInvite(content) {
    var aux = document.createElement("input");
    aux.setAttribute("value", content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
    this.setState({
      desc: this.state.lang.copySuc
    })
    this.refs.toast.hideRule(true)
  }

  onchangeCode(e) {
    this.setState({
      inpCode: e
    })
  }

  render() {
    return (
      <div className={`ramadan-help-main-wrap ${this.state.language == 'ar' && "arlang"}`}>

        <Toast ref="toast" toastContent={this.state.desc} />


        {
          this.state.isEmptyUid && (
            <div className="ramadan-help-top" onClick={() => { this.goAppShop() }}>
              <div className="top-pic"></div>
              <div className="top-info">
                <div className="title">App</div>
                <div className="txt">{this.state.lang.letgo}</div>
              </div>
              <div className="top-download" onClick={() => { this.goAppShop() }}>{this.state.lang.dl}</div>
            </div>
          )
        }

        <div className="ramadan-help-banner"></div>
        <div className="ramadan-help-cd">
          <CD leftTimestamp={this.state.cd} slot={this.timeComp} />
        </div>
        {
          !this.state.isEmptyUid && (
            <div className='people-num'>
              {this.state.lang.cuUser}: <span>{this.state.inviteTotal}</span>
            </div>
          )
        }
        <div className="ramadan-help-content">
          <div className="ramadan-help-content-pro">
            <div className={`${this.state.inviteTotal && this.state.inviteTotal >= 2 && "ramadan-help-content-pro-item1"}`}></div>
            <div className={`${this.state.inviteTotal && this.state.inviteTotal >= 4 && "ramadan-help-content-pro-item2"}`}></div>
            <div className={`${this.state.inviteTotal && this.state.inviteTotal >= 6 && "ramadan-help-content-pro-item3"}`}></div>
            <div className={`${this.state.inviteTotal && this.state.inviteTotal >= 8 && "ramadan-help-content-pro-item4"}`}></div>
          </div>
          <div className="ramadan-help-content-reward">
            <div className="ramadan-help-content-reward-item1" onClick={() => { this.onHandleGainRw(1) }}>
              <div>
                <img src="/img/activity/ramadan/jigsaw/fra.png" alt="" />
                <div className={`star ${this.state.rw1 && this.state.rw1.canGet && "star-active"}`}
                  style={{ display: `${this.state.rw1 && this.state.rw1.canGet ? "block" : "none"}` }}></div>
              </div>
              <span>Chip*1</span>
            </div>
            <div className="ramadan-help-content-reward-item2" onClick={() => { this.onHandleGainRw(2) }}>
              <div>
                <img src="/img/activity/ramadan/jigsaw/fra.png" alt="" />
                <div className={`star ${this.state.rw2 && this.state.rw2.canGet && "star-active"}`}
                  style={{ display: `${this.state.rw2 && this.state.rw2.canGet ? "block" : "none"}` }}></div>
              </div>
              <span>Chip*1</span>
            </div>
            <div className="ramadan-help-content-reward-item3" onClick={() => { this.onHandleGainRw(3) }}>
              <div>
                <img src="/img/activity/ramadan/jigsaw/fra.png" alt="" />
                <div className={`star ${this.state.rw3 && this.state.rw3.canGet && "star-active"}`}
                  style={{ display: `${this.state.rw3 && this.state.rw3.canGet ? "block" : "none"}` }}></div>
              </div>
              <span>Chip*1</span>
            </div>
            <div className="ramadan-help-content-reward-item4" onClick={() => { this.onHandleGainRw(4) }}>
              <div>
                <img src="/img/activity/ramadan/help/rw/rw2.png" alt="" />
                <div className={`star ${this.state.rw4 && this.state.rw4.canGet && "star-active"}`}
                  style={{ display: `${this.state.rw4 && this.state.rw4.canGet ? "block" : "none"}` }}></div>
              </div>
              <span>Chip*2</span>
              <span>Head*1</span>
              {/* <div className="btn">领取</div> */}
            </div>
          </div>
          <div className="ramadan-help-content-help">
            {
              // !this.state.isEmptyUid && (
              //   <div className="ramadan-help-content-help-txt">
              //     {/* 判断当前有没有在为别人助力，有就展示，没有就不展示 */}
              //     当前正在为{this.state.userInfo && this.state.userInfo.nickname}助力
              //     &nbsp;<br />
              //   </div>
              // )
            }

            {
              !this.state.isEmptyUid && (
                <div className='input-main'>
                  <span>{this.state.lang.enterI}</span><br />
                  <input type="text" className='inp' onChange={(e) => { this.onchangeCode(e.target.value) }} />
                </div>
              )
            }
            {
              !this.state.isEmptyUid && (
                <div className="ramadan-help-content-help-btn" onClick={() => this.helpUser()}>{this.state.lang.clickHelp}</div>
              )
            }
            {
              this.state.isEmptyUid && this.state.inviteCode && (
                <div className='inviteCode' onClick={() => { this.copyInvite(this.state.inviteCode) }}>
                  {this.state.lang.friendI}：
                  <span>{this.state.inviteCode}</span>
                </div>
              )
            }
            {
              this.state.isEmptyUid && (
                <div className="ramadan-help-content-help-desc" onClick={() => { this.goAppShop() }}>{this.state.lang.meAlso}</div>
              )
            }
          </div>
        </div>
        <div className="ramadan-help-reward">
          <div className="ramadan-help-reward-title">{this.state.lang.acShow}</div>

          {
            !this.state.isEmptyUid && (
              <RuleButton
                lang={this.state.lang}
                slotButtonComp={() => {
                  return (
                    <div className="ramadan-help-reward-rule">
                      <div className="question">!</div>
                      <span>{this.state.lang.rule}</span>
                    </div>
                  )
                }}
                slotContentComp={this.ruleContentComp} />
            )
          }


          {/* <div className="ramadan-help-reward-desc">达到100积分能获得五个碎片和吉祥物头像框</div> */}
          <div className="ramadan-help-reward-list">
            {
              this.state.rwList.map((item, index) => {
                return (
                  <div className="ramadan-help-reward-item" key={index}>
                    <div className="pic-box">
                      {item.type == 'svga' ? <div id="svga" src={item.img}></div> : <img src={item.img} alt="" />}
                    </div>
                    <span>{item.name}</span>
                    <span>
                      {item.date}
                    </span>
                  </div>
                )
              })
            }
          </div>
          {
            this.state.isEmptyUid && (
              <div className="ramadan-help-reward-join" onClick={() => { this.goAppShop() }}>{this.state.lang.meAlso2}</div>
            )
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// src/pages/activity/ramadanHelp/index.js